var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "letter-main-dark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 35,
    viewBox: "0 0 220 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11847",
    "data-name": "Group 11847",
    transform: "translate(-576 -1098.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18252",
    "data-name": "Path 18252",
    d: "M0,34.514V3.193A2.613,2.613,0,0,1,2.658.627V34.514Z",
    transform: "translate(576 1098.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18253",
    "data-name": "Path 18253",
    d: "M17.273.627,40.894,28.656V3.193A2.614,2.614,0,0,1,43.553.627V34.514H42.5L18.827,6.533v27.98H16.119V1.74A1.134,1.134,0,0,1,17.273.627Z",
    transform: "translate(574.073 1098.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18254",
    "data-name": "Path 18254",
    d: "M63.142,16.746H83.354v2.47H63.142V34.562H60.434V3.426a2.852,2.852,0,0,1,2.9-2.8H84.056V3.241H63.142Z",
    transform: "translate(568.772 1098.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18255",
    "data-name": "Path 18255",
    d: "M133.206,17.524C133.156,26.432,127.288,35,115.5,35S97.8,26.383,97.8,17.427C97.8,8.327,103.667,0,115.5,0s17.754,8.375,17.7,17.524m-32.749-.048c.05,7.648,5.065,15.1,15.045,15.1,10.031,0,15.1-7.456,15.1-15.1,0-7.842-5.016-15.055-15.1-15.055s-15.1,7.068-15.045,15.055",
    transform: "translate(564.304 1098.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18256",
    "data-name": "Path 18256",
    d: "M169.066,3.807a5.662,5.662,0,0,0-10.178,0l-14.27,30.707h7.172l3.009-6.39,2.668-5.955h-.01l6.52-14.426L170.5,22.169h0l3.165,7.042,2.455,5.3h7.222Z",
    transform: "translate(558.705 1098.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18257",
    "data-name": "Path 18257",
    d: "M195.711,34.514V3.143A2.563,2.563,0,0,1,198.318.627h3.964V34.514Z",
    transform: "translate(552.595 1098.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18258",
    "data-name": "Path 18258",
    d: "M245.659,34.506h-7.874l-10.23-11.328h-6.369V34.506h-6.621V3.093a2.565,2.565,0,0,1,2.613-2.52c4.7.011,9.392.046,14.088.046,8.275.048,12.637,5.373,12.637,11.23,0,4.648-2.206,9.344-8.876,10.651L245.659,34.07ZM221.186,6.573V17.416h10.081c4.213,0,6.018-2.71,6.018-5.421s-1.856-5.423-6.018-5.423Z",
    transform: "translate(550.341 1098.455)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.45c7b18e4e17d0cac37ade74a9c798dc.svg";
export { ForwardRef as ReactComponent };